angular.module('client-group', ['core'])
    .constant('ClientGroupConst', {
        eventUpdate: 'client-group.updated'
    })
    .factory('ClientGroup', function ($resource) {
        return $resource('/crm/api/client-group/:id', {}, {
            list: {method: 'GET', isArray: false},
            update: {method: 'PUT'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/client-group/autocomplete'}
        })
    })
    .service('ClientGroupService', function ($rootScope, modals, ClientGroup, ClientGroupConst) {
        this.edit = entity => {
            return modals.open('app/client-group/edit-modal.html', 'ClientGroupDialogController', angular.copy(entity), {size: 'md'}, "$ctrl");
        }
        this.add = () => {
            let entity = {
                active: true,
                defaults: false,
                id: null
            }
            return this.edit(entity)
        }
        this.remove = item => {
            return modals.confirmDelete(item.name, () => ClientGroup.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(ClientGroupConst.eventUpdate)))
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('clientGroupList', {
            parent: 'app',
            url: '/client-group?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'clientGroupList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (ClientGroup, $stateParams) => ClientGroup.list(angular.copy($stateParams)).$promise
            }
        })
    })
